import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import TextRenderer from '../../../TextRenderer';
import CommissionViewer from '../../../DaEditorWrapper/Viewer/Commission';
import MeasuredTorpedo from '../../../Torpedo/MeasuredTorpedo';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import { MeasuredCookieType } from '../../../Measured';
import MediaService from '../../../utils/DeviationMediaService';
import s from './Commission.scss';
var exampleRenderer = function (renderProps, item) {
    return (React.createElement(DeviationDumbView, { deviation: item.dto.deviation, width: item.width, height: item.height }));
};
export var CommissionDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, _c = _b.commission, _d = (_c === void 0 ? {} : _c).examples, examples = _d === void 0 ? [] : _d, textContent = _b.textContent;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(SubmissionDetails, { deviation: deviation }),
        textContent && (React.createElement(TextRenderer, { className: s['description'], textContent: textContent, viewerKey: deviation.deviationId, reactViewer: CommissionViewer })),
        examples.length > 0 && (React.createElement("div", { className: s['examples'] },
            React.createElement(MeasuredTorpedo, { container: { width: 780 }, items: examples.map(function (item) {
                    var largest = MediaService.getLargestFullview(item);
                    return {
                        id: "deviation-" + item.deviationId,
                        width: largest.width || 0,
                        height: largest.height || 0,
                        deviation: item,
                    };
                }), renderItem: exampleRenderer, cookieDim: "width", cookieType: MeasuredCookieType.BROWSE })))));
};
CommissionDetails.displayName = 'CommissionDetails';
export default CommissionDetails;
//# sourceMappingURL=Commission.js.map